import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {JobStatusConfiguration} from '../models/job.status/jobStatusConfiguration.model';
import {JobStatus} from '../models/job.status/jobStatus.model';
import {JobStatusSearchRequest} from '../models/job.status/jobStatusSearch.model';
import {SearchJob} from '../models/search/searchJob.model';

@Injectable({
  providedIn: 'root'
})
export class JobStatusService {

  private JOB_STATUS_URL: string = environment.BASE_URL + 'job/status';
  private JOB_URL: string = environment.BASE_URL + 'job';

  constructor(private http: HttpClient) {
  }

  public getConfigurations(): Observable<Array<JobStatusConfiguration>> {
    return this.http.get<Array<JobStatusConfiguration>>(`${this.JOB_STATUS_URL}/configurations`);
  }

  public getConfiguration(id: string): Observable<JobStatusConfiguration> {
    return this.http.get<JobStatusConfiguration>(`${this.JOB_STATUS_URL}/configurations/${id}`);
  }

  public createConfiguration(configuration: JobStatusConfiguration): Observable<JobStatusConfiguration> {
    return this.http.post<JobStatusConfiguration>(`${this.JOB_STATUS_URL}/configurations`, configuration);
  }

  public updateConfiguration(configuration: JobStatusConfiguration): Observable<JobStatusConfiguration> {
    return this.http.patch<JobStatusConfiguration>(`${this.JOB_STATUS_URL}/configurations/${configuration.id}`, configuration);
  }

  public deleteConfiguration(id: string): Observable<JobStatusConfiguration> {
    return this.http.delete<JobStatusConfiguration>(`${this.JOB_STATUS_URL}/configurations/${id}`);
  }

  public search(request: JobStatusSearchRequest): Observable<Array<SearchJob>> {
    return this.http.post<Array<SearchJob>>(`${this.JOB_STATUS_URL}/search`, request);
  }

  public getJobStatus(jobId: string): Observable<JobStatus> {
    return this.http.get<JobStatus>(`${this.JOB_URL}/${jobId}/status`);
  }

  public updateJobStatus(jobId: string, statusId: string): Observable<JobStatus> {
    return this.http.patch<JobStatus>(`${this.JOB_URL}/${jobId}/status`, {statusId});
  }

  public addComment(jobId: string, comment: string): Observable<JobStatus> {
    return this.http.post<JobStatus>(`${this.JOB_URL}/${jobId}/status/comment`, {comment});
  }
}
